import React from 'react';
import { get, map } from 'lodash';
import { MD, SM } from '@zendeskgarden/react-typography';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { ProductsSectionHeader } from 'routes/Products/Products.styles';
import { productNominalDetailsShape } from 'propTypesObjects';
import { PropTypes } from 'prop-types';
import { webRefactorSwitch } from '../../../../utility/environment';
import {
  EndFinishDetailsCard,
  AttributesCol,
  DescriptionRow,
} from './ProductsEndFinishDetails.styles';

function ProductsEndFinishDetails({ productDetails, listingsRefactor }) {
  const {
    name, // "Plain End"
    description, // null
    thread_type_name: threadTypeName,
    category_name: categoryName,
    licensee, // null
  } = productDetails?.end_finish || {};
  const lotSummary = productDetails?.result?.lot_summary;

  const attributes = [
    {
      title: 'Name',
      value: name,
    },
    {
      title: 'Licensee',
      value: get(licensee, 'name'),
    },
    {
      title: 'Category',
      value: categoryName,
    },

    {
      title: 'Thread Type',
      value: threadTypeName,
    },
  ];

  return (
    <EndFinishDetailsCard
      listingsRefactor={listingsRefactor}
      isNotProd={webRefactorSwitch}
    >
      <Grid>
        <Row>
          <Col>
            {lotSummary && (
              <ProductsSectionHeader
                tag="h2"
                style={{ fontSize: '26px', marginBottom: '20px' }}
                paddingBottomMd
                scaled
                bold
              >
                Connection Details
              </ProductsSectionHeader>
            )}
          </Col>
        </Row>

        <Row>
          {map(attributes, (attribute, i) => (
            <AttributesCol
              className="connectionDetailsAttributes"
              size="auto"
              key={i}
            >
              <MD paddingBottomSm as="h3" bold>
                {attribute.title}
              </MD>
              <MD paddingBottomSm as="h3">
                {attribute.value || '--'}
              </MD>
            </AttributesCol>
          ))}
        </Row>

        <DescriptionRow
          listingsRefactor={listingsRefactor}
          isNotProd={webRefactorSwitch}
        >
          <Col size="auto">
            <MD paddingBottomSm as="h3" bold>
              Description
            </MD>
            <SM paddingBottomSm as="h3">
              {description || '--'}
            </SM>
          </Col>
        </DescriptionRow>
      </Grid>
    </EndFinishDetailsCard>
  );
}

ProductsEndFinishDetails.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};

export default ProductsEndFinishDetails;
